export function getComplex(complexId, query = '') {
  return { path: `complexes/${complexId}${query}` };
}

export function searchComplexes(query) {
  return { path: `complexes${query}&expand=buildings` };
}

export function createComplex(name) {
  return {
    path: 'complexes',
    method: 'POST',
    body: JSON.stringify({ name }),
  };
}

export function updateComplex(complexId, newName) {
  return {
    body: JSON.stringify({ name: newName }),
    path: `complexes/${complexId}`,
    method: 'PUT',
  };
}

export function deleteComplex(complexId) {
  return {
    path: `complexes/${complexId}`,
    method: 'DELETE',
  };
}

export function getComplexNasProfiles(complexId) {
  return { path: `complexes/${complexId}/nas_profiles` };
}

export function getComplexProducts(complexId) {
  return { path: `complexes/${complexId}/products` };
}

export function updateComplexVlans(complexId, body) {
  return {
    path: `complexes/${complexId}/update_vlans`,
    method: 'POST',
    body: JSON.stringify(body),
  };
}

export function getOrderedVlanBuildingRows(complexId, body) {
  return {
    path: `complexes/${complexId}/ordered_vlan_rows`,
    method: 'POST',
    body: JSON.stringify(body),
  };
}

export function moveVlanBuildingRows(complexId, body) {
  return {
    path: `complexes/${complexId}/move_vlan_rows`,
    method: 'POST',
    body: JSON.stringify(body),
  };
}
